<script setup lang="ts">
import { defineComponent } from 'vue'
import { RouterView } from 'vue-router'
import { definePage } from 'vue-router/auto'
import ThemeToggle from '~/components/shared/ThemeToggle.vue'
import LanguageToggle from '~/components/shared/LanguageToggle.vue'
import { useBranding } from '~/services/auth/useBranding'
import { apiUrl, APP_NAME } from '~/utils/constants'

definePage({
  meta: {
    requiresAuth: false,
  },
})

defineComponent({
  name: 'AuthLayout',
})

const { branding } = useBranding()
</script>

<template>
  <div class="flex min-h-screen flex-col bg-background text-foreground">
    <header class="flex items-center justify-between gap-4 border-b px-4 py-3 sm:px-6">
      <img :src="`${apiUrl()}/img/inctrl-logo.svg`" :alt="APP_NAME" class="h-7" />
      <div class="flex items-center gap-3">
        <LanguageToggle />
        <ThemeToggle />
      </div>
    </header>
    <main class="flex flex-1 items-center justify-center px-4 py-8 sm:px-6 sm:py-12">
      <RouterView />
    </main>
    <footer
      class="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 border-t border-border/60 px-4 py-4 text-[13px] leading-[18px] text-muted-foreground sm:px-6"
    >
      <a
        v-if="branding.privacy_policy_url"
        :href="branding.privacy_policy_url"
        target="_blank"
        rel="noopener"
        class="underline hover:text-foreground"
      >
        {{ $t('Privacy statement') }}
      </a>
      <span v-else />
      <span>inCTRL powered by sirine.ai</span>
    </footer>
  </div>
</template>

<route lang="json">
{
  "meta": {
    "requiresAuth": false
  }
}
</route>
